import { push } from 'redux-first-router';

import { trackCompleteGameOrder } from '../trackCompleteGameOrder';
import { selectPostCompleteOrderUrl } from '../selectPostCompleteOrderUrl';
import { awinAffiliateInfo } from '../awinAffiliateInfo.js';
import { tikTokEventApiAffiliateInfo } from '../tiktokEventApiInfo';

export async function completeGameOrder({
  bets,
  games,
  isAdHocMembershipOrder,
  membershipReturnGame,
  mutation,
  nonce,
  orderId,
  payAmount,
  referringGameId,
  requiresRegistration = false,
  setMembershipReturnGame,
  storeInVault,
  theme,
  timeZone,
  userId,
  geo,
}) {
  const mutationVariables = {
    orderId,
    payAmount,
    timeZone,
    nonce,
    storeInVault,
    awinAffiliateInfo: awinAffiliateInfo(orderId, payAmount),
    tikTokEventApiAffiliateInfo: tikTokEventApiAffiliateInfo(orderId),
  };
  const combinedGames = [...(games || []), ...(bets || [])];

  if (isAdHocMembershipOrder)
    mutationVariables.referringGameId = referringGameId;

  const { data } = await mutation(mutationVariables);

  const order = data?.completeOrderV2;
  if (!order) throw new Error('Could not complete order.');

  const trackCompleteGameOrderCallback = trackCompleteGameOrder({
    order,
    referringGameId,
    userId,
    geo,
  });

  const { game } = combinedGames[0] || {};

  isAdHocMembershipOrder && setMembershipReturnGame(null);

  push(
    selectPostCompleteOrderUrl({
      game,
      isAdHocMembershipOrder,
      membershipReturnGame,
      order,
      requiresRegistration,
      theme,
    })
  );

  // fire the Order Completed event on success screen (one of the urls being
  // pushed above), _not_ the checkout screen
  setTimeout(trackCompleteGameOrderCallback, 0);

  return data.order;
}
